<template>
  <div class="alert alert-light border d-flex align-items-center">
    <i class="fa-solid fa-wifi mr-3"></i>
    <div>
      <h6 class="font-weight-bold mb-0">Desconectado</h6>
      <p class="mb-0">Verifique sua conexão com a Internet</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "COffline"
}
</script>

<style scoped>

</style>
